<template>
  <el-dialog :title="$t('winrd.nodes.edit')" :close-on-click-modal="false" :visible.sync="visible"
    @closed="reset">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="auto">
      <el-form-item label="ID" :label-width="formLabelWidth" prop="id">
        <el-input v-model="dataForm.id" disabled autocomplete="off" />
      </el-form-item>
      <el-form-item :label="$t('winrd.nodes.server_name')" :label-width="formLabelWidth" prop="name">
        <el-input v-model="dataForm.name" disabled autocomplete="off" />
      </el-form-item>
      <el-form-item :label="$t('winrd.nodes.server_ip')" :label-width="formLabelWidth" prop="hostname">
        <el-input v-model="dataForm.hostname" disabled autocomplete="off" />
      </el-form-item>
      <el-form-item :label="$t('winrd.nodes.protocol')" :label-width="formLabelWidth" prop="protocol">
        <el-select v-model="dataForm.protocol" disabled :placeholder="$t('winrd.nodes.protocol_rdp')" value="0">
          <el-option :label="$t('winrd.nodes.protocol_rdp')" value="0" />
          <el-option :label="$t('winrd.nodes.protocol_vnc')" disabled value="1" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('winrd.nodes.port')" :label-width="formLabelWidth" prop="port">
        <el-input v-model="dataForm.port" disabled autocomplete="off" />
      </el-form-item>
      <el-form-item :label="$t('winrd.nodes.os')" :label-width="formLabelWidth" prop="os">
        <el-select v-model="dataForm.os" disabled :placeholder="$t('winrd.nodes.os_windows')" value="Windows">
          <el-option :label="$t('winrd.nodes.os_windows')" value="Windows" />
          <el-option :label="$t('winrd.nodes.os_linux')" disabled value="Linux" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('winrd.nodes.admin_user')" :label-width="formLabelWidth" prop="admin_username">
        <el-input v-model="dataForm.admin_username" autocomplete="off" />
      </el-form-item>
      <el-form-item :label="$t('winrd.nodes.admin_password')" :label-width="formLabelWidth" prop="admin_password">
        <el-input v-model="dataForm.admin_password" autocomplete="off" />
      </el-form-item>
      <el-form-item :label="$t('winrd.nodes.status')" :label-width="formLabelWidth" prop="is_lock">
        <el-radio-group v-model="dataForm.is_lock">
          <el-radio :label="0">{{$t('winrd.nodes.normal')}}</el-radio>
          <el-radio :label="1">{{$t('winrd.nodes.locked')}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$t('winrd.nodes.remark')" :label-width="formLabelWidth" prop="remark">
        <el-input v-model="dataForm.remark" autocomplete="off" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{$t('winrd.nodes.cancel')}}</el-button>
      <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">{{$t('winrd.nodes.confirm')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { validateIP } from '../../utils/validation'
import { eventBus } from '@containers/WinRD/utils/eventBus' // 全局事件总线

export default {
  data () {
    return {
      visible: false,
      submitLoading: false,
      appTypeList: [],
      is_lock: [
        { id: 0, name: this.$t('winrd.nodes.normal') },
        { id: 1, name: this.$t('winrd.nodes.abnormal') },
      ],
      dataForm: {
        id: '',
        name: '',
        hostname: '',
        protocol: '0',
        port: '3389',
        os: 'Windows',
        admin_username: '',
        admin_password: '',
        is_lock: 0,
        remark: '',
      },
      dataRule: {
        name: [{
          required: true,
          message: this.$t('winrd.nodes.input_server_name'),
          trigger: 'blur',
        }],
        hostname: [{
          required: true,
          message: this.$t('winrd.nodes.input_server_ip'),
          trigger: 'blur',
        },
        { validator: validateIP, trigger: 'blur' },
        ],
        protocol: [{
          required: true,
          message: this.$t('winrd.nodes.select_protocol'),
          trigger: 'blur',
        }],
        port: [{
          required: true,
          message: this.$t('winrd.nodes.input_port'),
          trigger: 'blur',
        }],
        admin_username: [{
          required: true,
          message: this.$t('winrd.nodes.input_admin_user'),
          trigger: 'blur',
        }],
      },
    }
  },
  methods: {
    init (row, appTypeList) {
      this.visible = true
      this.appTypeList = appTypeList
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
        // 对dataForm的赋值，需要滞后，以免变成默认值，reset时出问题
        this.dataForm.id = row.id
        if (this.dataForm.id != null) {
          this.dataForm = {
            id: row.id,
            name: row.name,
            hostname: row.hostname,
            protocol: row.protocol,
            port: row.port,
            os: row.os,
            admin_username: row.admin_username,
            admin_password: row.admin_password,
            is_lock: row.is_lock,
            remark: row.remark,
          }
        }
      })
    },
    reset () {
      this.$refs.dataForm.resetFields()
    },

    // 表单提交
    async dataFormSubmit () {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          const tmp = { ...this.dataForm }

          this.$axios.post('/api/sa/rdbackend/change_remote', tmp, {
            headers: {
              'Content-Type': 'application/json',
            },
          }).then(response => {
            this.visible = false
            this.submitLoading = false
            this.$message({
              message: response.data.message,
              type: 'success',
              duration: 1500,
            })
            // 触发事件
            eventBus.$emit('refresh-list')
          }).catch(error => {
            this.$message({
              message: error.response.data.error,
              type: 'error',
              duration: 1500,
            })
            this.submitLoading = false
          })
        }
      })
    },
  },
}
</script>
